// Tiny modal helper for collecting a single text input.
// Backed by a native <dialog> in index.html.

const DIALOG_ID = 'add-modal';
const TITLE_ID  = 'add-modal-title';
const INPUT_ID  = 'add-modal-input';

// Wire the Cancel button once. It's type="button" so it doesn't act as the
// implicit form submitter when the user presses Enter — Enter now activates
// the only remaining submit button ("Create"), which is the desired behavior.
let cancelWired = false;
function ensureCancelWired(dialog: HTMLDialogElement): void {
  if (cancelWired) return;
  const cancelBtn = dialog.querySelector('[data-cancel]') as HTMLButtonElement | null;
  cancelBtn?.addEventListener('click', () => dialog.close('cancel'));
  cancelWired = true;
}

/**
 * Opens the shared <dialog>, returns the trimmed text on confirm or `null` on cancel/Escape.
 */
export function openTextPrompt(title: string, placeholder = 'Label'): Promise<string | null> {
  const dialog  = document.getElementById(DIALOG_ID)  as HTMLDialogElement;
  const input   = document.getElementById(INPUT_ID)   as HTMLInputElement;
  const titleEl = document.getElementById(TITLE_ID)   as HTMLElement;

  ensureCancelWired(dialog);

  titleEl.textContent = title;
  input.placeholder   = placeholder;
  input.value         = '';

  return new Promise<string | null>((resolve) => {
    const onClose = (): void => {
      dialog.removeEventListener('close', onClose);
      const value = input.value.trim();
      resolve(dialog.returnValue === 'confirm' && value.length > 0 ? value : null);
    };
    dialog.addEventListener('close', onClose);
    dialog.showModal();
    input.focus();
    input.select();
  });
}

// ─── Description modal (bigger — textarea) ───────────────────────────────────

const DESC_DIALOG_ID = 'desc-modal';
const DESC_TITLE_ID  = 'desc-modal-title';
const DESC_INPUT_ID  = 'desc-modal-input';

let descCancelWired = false;
function ensureDescCancelWired(dialog: HTMLDialogElement): void {
  if (descCancelWired) return;
  const cancelBtn = dialog.querySelector('[data-cancel]') as HTMLButtonElement | null;
  cancelBtn?.addEventListener('click', () => dialog.close('cancel'));
  descCancelWired = true;
}

/**
 * Opens the larger description <dialog> seeded with `current`. Resolves to the
 * new text on Save (empty string allowed — clears the description) or `null` on
 * cancel/Escape.
 */
export function openDescriptionModal(title: string, current: string): Promise<string | null> {
  const dialog  = document.getElementById(DESC_DIALOG_ID) as HTMLDialogElement;
  const input   = document.getElementById(DESC_INPUT_ID)  as HTMLTextAreaElement;
  const titleEl = document.getElementById(DESC_TITLE_ID)   as HTMLElement;

  ensureDescCancelWired(dialog);

  titleEl.textContent = title;
  input.value         = current;

  return new Promise<string | null>((resolve) => {
    const onClose = (): void => {
      dialog.removeEventListener('close', onClose);
      resolve(dialog.returnValue === 'confirm' ? input.value.trim() : null);
    };
    dialog.addEventListener('close', onClose);
    dialog.showModal();
    input.focus();
  });
}
